import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import BlockPlaceholder from 'components/consumer/BlockPlaceholder';
import JBImage from 'components/essentials/JBImage';
import useScreen from 'hooks/useScreen';
const InspirationPhotoCard = t0 => {
  const $ = _c(42);
  const {
    hits,
    hoveredValue,
    index,
    onHoverHandler,
    photo,
    toggleModalView
  } = t0;
  const {
    isMobileOrTablet
  } = useScreen();
  const [imageLoaded, setImageLoaded] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setImageLoaded(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const setImageIsLoaded = t1;
  if (!photo) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="w-full min-h-[20vh] text-base text-[#5c5c5c] flex items-center justify-center">No product found!</div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  const imgHeight = isMobileOrTablet ? 350 : 260;
  let t2;
  if ($[2] !== onHoverHandler || $[3] !== photo.photo_id) {
    t2 = () => onHoverHandler(photo.photo_id);
    $[2] = onHoverHandler;
    $[3] = photo.photo_id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onHoverHandler) {
    t3 = () => onHoverHandler("out");
    $[5] = onHoverHandler;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== hits || $[8] !== index || $[9] !== photo || $[10] !== toggleModalView) {
    t4 = () => toggleModalView(photo, hits, index);
    $[7] = hits;
    $[8] = index;
    $[9] = photo;
    $[10] = toggleModalView;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classNames("w-full h-full relative", "before:[content:\"\"] before:block before:pt-[100%]", "[&_img]:h-full [&_img]:left-0 [&_img]:absolute [&_img]:top-0 [&_img]:w-full [&_img]:[-webkit-user-select:none] [&_img]:[-webkit-touch-callout:none]");
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== imageLoaded || $[14] !== imgHeight) {
    t6 = !imageLoaded ? <BlockPlaceholder className="!w-full" style={{
      height: imgHeight
    }} /> : null;
    $[13] = imageLoaded;
    $[14] = imgHeight;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = photo.photo_id;
  let t8;
  if ($[16] !== photo.image_link) {
    t8 = photo.image_link.replace("pstatic.joybird.com", "inspire.imgix.net");
    $[16] = photo.image_link;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = !imageLoaded;
  let t10;
  if ($[18] !== imageLoaded || $[19] !== t9) {
    t10 = classNames("align-middle object-cover w-full [transition:opacity_.3s_ease-in-out]", {
      "opacity-10": t9,
      "opacity-100": imageLoaded
    });
    $[18] = imageLoaded;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== imgHeight || $[22] !== photo.photo_id || $[23] !== t10 || $[24] !== t8) {
    t11 = <JBImage height={imgHeight} width={300} alt={t7} src={t8} trim="auto" className={t10} onLoad={setImageIsLoaded} />;
    $[21] = imgHeight;
    $[22] = photo.photo_id;
    $[23] = t10;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t6) {
    t12 = <div className={t5}>{t6}{t11}</div>;
    $[26] = t11;
    $[27] = t6;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== hoveredValue.hoveredOver || $[30] !== hoveredValue.isHovered || $[31] !== imageLoaded || $[32] !== photo.customer_first_name || $[33] !== photo.customer_last_name || $[34] !== photo.photo_id) {
    t13 = hoveredValue.hoveredOver === photo.photo_id && imageLoaded ? <div className={classNames("text-white [transition:opacity_ease-in] absolute top-0 left-0 bg-[rgba(0,0,0,.5)] w-full min-h-full flex items-center justify-center pointer-events-none z-10 max-[1440px]:w-full max-[1023px]:w-full max-[564px]:hidden", {
      hide: !hoveredValue.isHovered,
      "opacity-100": hoveredValue.isHovered
    })}><div className="relative h-[255px] flex items-center flex-col justify-center"><div className="text-[.8rem] font-bold mx-auto my-2 w-full">{photo.customer_first_name || photo.customer_last_name ? `${photo.customer_first_name || ""} ${photo.customer_last_name.charAt(0) || ""}` : "Joybird customer"}</div></div></div> : null;
    $[29] = hoveredValue.hoveredOver;
    $[30] = hoveredValue.isHovered;
    $[31] = imageLoaded;
    $[32] = photo.customer_first_name;
    $[33] = photo.customer_last_name;
    $[34] = photo.photo_id;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t12 || $[37] !== t13 || $[38] !== t2 || $[39] !== t3 || $[40] !== t4) {
    t14 = <button type="button" className="flex relative cursor-pointer flex-col items-center justify-center md:mb-[.3rem] min-[1440px]:mb-4 max-[1440px]:w-[33%] max-[1023px]:w-[49.7%] !w-full h-full border-0 !mb-0" onMouseOver={t2} onMouseOut={t3} onClick={t4}>{t12}{t13}</button>;
    $[36] = t12;
    $[37] = t13;
    $[38] = t2;
    $[39] = t3;
    $[40] = t4;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
};
InspirationPhotoCard.propTypes = {
  hits: PropTypes.array,
  hoveredValue: PropTypes.shape({
    hoveredOver: PropTypes.string,
    isHovered: PropTypes.bool
  }),
  index: PropTypes.number,
  onHoverHandler: PropTypes.func,
  photo: PropTypes.shape({
    customer_first_name: PropTypes.string,
    customer_last_name: PropTypes.string,
    image_link: PropTypes.string,
    photo_comment: PropTypes.string,
    photo_id: PropTypes.string,
    products: PropTypes.array
  }),
  toggleModalView: PropTypes.func
};
export default InspirationPhotoCard;